// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Peers.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { RetrieveShardRequest, StoreShardResponse } from "./DriveHost";
import { ShardChunk } from "./Models/DriveModels";

export const protobufPackage = "daisi.protos.v1";

export type PeersProtoDefinition = typeof PeersProtoDefinition;
export const PeersProtoDefinition = {
  name: "PeersProto",
  fullName: "daisi.protos.v1.PeersProto",
  methods: {
    transferShard: {
      name: "TransferShard",
      requestType: ShardChunk,
      requestStream: true,
      responseType: StoreShardResponse,
      responseStream: false,
      options: {},
    },
    requestShard: {
      name: "RequestShard",
      requestType: RetrieveShardRequest,
      requestStream: false,
      responseType: ShardChunk,
      responseStream: true,
      options: {},
    },
  },
} as const;

export interface PeersProtoServiceImplementation<CallContextExt = {}> {
  transferShard(
    request: AsyncIterable<ShardChunk>,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<StoreShardResponse>>;
  requestShard(
    request: RetrieveShardRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<ShardChunk>>;
}

export interface PeersProtoClient<CallOptionsExt = {}> {
  transferShard(
    request: AsyncIterable<DeepPartial<ShardChunk>>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<StoreShardResponse>;
  requestShard(
    request: DeepPartial<RetrieveShardRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<ShardChunk>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };
